// API Configuration centralized
export const API_CONFIG = {
  // Main APIs
  JAGOTA_NODE_API: process.env.NEXT_PUBLIC_JAGOTA_NODE_API_URL,
  SERVERLESS_API: process.env.NEXT_PUBLIC_SERVERLESS_API,
  
  // Default values
  DEFAULT_P_COM: process.env.NEXT_PUBLIC_DEFAULT_P_COM || 'JB',
  DEFAULT_P_USER: process.env.NEXT_PUBLIC_DEFAULT_P_USER || 'JBT04',
} as const;

// API Endpoints - organized by service
export const API_ENDPOINTS = {
  // Serverless API endpoints
  LEADS: {
    BASE: `${API_CONFIG.SERVERLESS_API}/leads`,
    CHECK_USER: (lineId: string) => `${API_CONFIG.SERVERLESS_API}/leads/lineId/${lineId}`,
    CREATE_USER: `${API_CONFIG.SERVERLESS_API}/leads`,
    UPDATE_USER: (userId: string) => `${API_CONFIG.SERVERLESS_API}/leads/${userId}`,
    USER_GIFTS: (leadId: string, eventId: string) => `${API_CONFIG.SERVERLESS_API}/leads/gifts/${leadId}/${eventId}`,
    USER_EVENTS: `${API_CONFIG.SERVERLESS_API}/leads/user-events`,
  },
  
  // Jagota Node API endpoints
  JAGOTA: {
    BASE: API_CONFIG.JAGOTA_NODE_API,
    COMPANY_EVENTS: `${API_CONFIG.JAGOTA_NODE_API}/v1/public/company-events`,
  },
  
  // Add more API services here as needed
  // PAYMENT_API: { ... },
  // NOTIFICATION_API: { ... },
} as const;

// Helper function to validate required environment variables
export const validateApiConfig = (throwError = false) => {
  const required = ['NEXT_PUBLIC_SERVERLESS_API'];
  const missing = required.filter(key => !process.env[key]);
  
  if (missing.length > 0) {
    const message = `Missing required environment variables: ${missing.join(', ')}`;
    console.error(message);
    console.error('Available env vars:', Object.keys(process.env).filter(key => key.startsWith('NEXT_PUBLIC_')));
    
    if (throwError) {
      throw new Error(message);
    }
    return false;
  }
  return true;
};